<script>
  import { cn } from '@lib/utils'

  let { children, class: className } = $props()

  let itemsClass = $derived(cn("grid grid-cols-12 gap-8", className))
</script>

<div class={itemsClass}>
  {@render children?.()}
</div>